<template>
  <!-- Navigation -->
  <nav
    class="navbar navbar-expand-lg navbar-light fixed-top"
    id="mainNav"
    :class="backbg"
  >
    <div class="container">
      <button
        class="navbar-toggler navbar-toggler-right"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="clickMenu"
      >
        Menu
        <i class="fas fa-bars"></i>
      </button>
      <div
        class="collapse navbar-collapse"
        :class="active"
        id="navbarResponsive"
      >
        <ul class="navbar-nav ml-auto">
          <li @click="clickItem(false)" class="nav-item">
            <router-link class="nav-link js-scroll-trigger" to="/"
              >CHARGING SHOW
            </router-link>
          </li>
          <li @click="clickItem('features')" class="nav-item">
            <router-link class="nav-link js-scroll-trigger" to="/"
              >Features</router-link
            >
          </li>
          <li @click="clickItem('contact')" class="nav-item">
            <router-link class="nav-link js-scroll-trigger" to="/"
              >Contact</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      spread: false,
      backbg: "",
      active: ""
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.backbg = val.path !== "/" ? "backbg" : "";
      },
      immediate: true
    }
  },
  methods: {
    clickMenu() {
      this.active = this.active ? "" : "show";
    },
    clickItem(val) {
      if (val) {
        setTimeout(() => {
          const dom = document.querySelector("#" + val);
          const domTop = dom && dom.getBoundingClientRect().top;
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop;
          window.scrollTo(0, domTop + scrollTop);
        }, 0);
      } else {
        setTimeout(() => {
          window.scrollTo(0, 0);
        });
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.backbg = scrollTop < 80 ? "" : "backbg";
    });
    const redirectedFrom = this.$route.redirectedFrom;
    if (redirectedFrom === "/contact") {
      this.clickItem("contact");
    }
  }
};
</script>
<style scoped>
.backbg {
  background: rgb(160, 194, 226) !important;
}
.backbg a {
  color: #000 !important;
}
</style>
